export const lineTypes = [
  [5, 0, 5, 0],
];

export const lineTypesBookmark = [
  [10, 0, 10, 0],
  [15, 20, 15, 20],
  [10, 0, 10, 0],
  [10, 0, 10, 0],
  [10, 0, 10, 0],
  [10, 0, 10, 0],
  [10, 0, 10, 0],
  [1, 15, 1, 15],
  [10, 0, 10, 0],
  [10, 0, 10, 0],
  [15, 20, 15, 20],
  [10, 0, 10, 0],
  [15, 20, 15, 20],
  [1, 15, 1, 15],
  [10, 0, 10, 0],
];

export const lineWidths = ['1', '3', '4', '2', '2', '2', '2', '2', '2', '8', '1', '2', '2', '2', '2'];
export const symbols = ['none', 'none', 'none', 'circle', 'rect', 'triangle', 'diamond', 'diamond', 'rect', 'none', 'none', 'circle', 'none', 'none', 'triangle'];
export const symbolSizes = ['none', 'none', 'none', '10', '8', '10', '10', '6', '10', 'none', 'none', '12', 'none', 'none', '10'];
export const symbolColors = ['none', 'none', 'none', '#ff0000', '#73c0de', '#8DCC77', '#5373c7', '#FFC458', '#9D5EB6', 'none', 'none', '#E878CA', 'none', 'none', '#FD8054'];

export function getLineTypesListByLength(itemsAmount) {
  const currentLineTypes = lineTypes;
  const colorsLength = currentLineTypes.length;
  const cyclicLineTypesListByAmount = [];
  for (let index = 0; index < itemsAmount; index += 1) {
    cyclicLineTypesListByAmount.push(
      currentLineTypes[((index % colorsLength) + colorsLength) % colorsLength],
    );
  }
  return cyclicLineTypesListByAmount;
}

export function getLineTypesBookmarkListByLength(itemsAmount) {
  const currentLineTypes = lineTypesBookmark;
  const colorsLength = currentLineTypes.length;
  const cyclicLineTypesListByAmount = [];
  for (let index = 0; index < itemsAmount; index += 1) {
    cyclicLineTypesListByAmount.push(
      currentLineTypes[((index % colorsLength) + colorsLength) % colorsLength],
    );
  }
  return cyclicLineTypesListByAmount;
}

export function getLineWidthListByLength(itemsAmount) {
  const currentLineTypes = lineWidths;
  const colorsLength = currentLineTypes.length;
  const cyclicLineTypesListByAmount = [];
  for (let index = 0; index < itemsAmount; index += 1) {
    cyclicLineTypesListByAmount.push(
      currentLineTypes[((index % colorsLength) + colorsLength) % colorsLength],
    );
  }
  return cyclicLineTypesListByAmount;
}

export function getLineSymbolsListByLength(itemsAmount) {
  const currentLineTypes = symbols;
  const colorsLength = currentLineTypes.length;
  const cyclicLineTypesListByAmount = [];
  for (let index = 0; index < itemsAmount; index += 1) {
    cyclicLineTypesListByAmount.push(
      currentLineTypes[((index % colorsLength) + colorsLength) % colorsLength],
    );
  }
  return cyclicLineTypesListByAmount;
}
export function getLineSymbolSizeListByLength(itemsAmount) {
  const currentLineTypes = symbolSizes;
  const colorsLength = currentLineTypes.length;
  const cyclicLineTypesListByAmount = [];
  for (let index = 0; index < itemsAmount; index += 1) {
    cyclicLineTypesListByAmount.push(
      currentLineTypes[((index % colorsLength) + colorsLength) % colorsLength],
    );
  }
  return cyclicLineTypesListByAmount;
}

export function getLineSymbolColorListByLength(itemsAmount) {
  const currentLineTypes = symbolColors;
  const colorsLength = currentLineTypes.length;
  const cyclicLineTypesListByAmount = [];
  for (let index = 0; index < itemsAmount; index += 1) {
    cyclicLineTypesListByAmount.push(
      currentLineTypes[((index % colorsLength) + colorsLength) % colorsLength],
    );
  }
  return cyclicLineTypesListByAmount;
}

